<template>
  <figure class="click-film">
    <button ref="trigger" class="film-poster" type="button" @click="open">
      <img :src="poster" :alt="title" loading="lazy" /><span
        >{{ zh ? "播放影片" : "Play film" }} ▷</span
      >
    </button>
    <figcaption>
      <span>{{ title }} · {{ credit }}</span
      ><a :href="source" target="_blank" rel="noopener noreferrer"
        >YouTube ↗︎</a
      >
    </figcaption>
    <dialog ref="dialog" class="motion-dialog" @close="closed" @click="backdrop" :aria-label="title">
      <header>
        <h2>{{ title }}</h2>
        <button type="button" @click="close">
          {{ zh ? "關閉" : "Close" }} ×
        </button>
      </header>
      <iframe
        v-if="active"
        :src="
          'https://www.youtube-nocookie.com/embed/' + videoId + '?playsinline=1'
        "
        :title="title"
        allow="encrypted-media; picture-in-picture"
        allowfullscreen
      ></iframe>
    </dialog>
  </figure>
</template>
<script setup>
import { ref, onBeforeUnmount } from "vue";
defineProps({
  videoId: String,
  title: String,
  poster: String,
  credit: String,
  source: String,
  zh: Boolean,
});
const dialog = ref(null),
  trigger = ref(null),
  active = ref(false);
function open() {
  active.value = true;
  dialog.value.showModal();
}
function close() {
  dialog.value.close();
}
function closed() {
  active.value = false;
  trigger.value?.focus();
}
function backdrop(e) {
  if (e.target === dialog.value) {
    const r = dialog.value.getBoundingClientRect();
    if (
      e.clientX < r.left ||
      e.clientX > r.right ||
      e.clientY < r.top ||
      e.clientY > r.bottom
    )
      close();
  }
}
onBeforeUnmount(() => {
  dialog.value?.close();
});
</script>
<style scoped>
.click-film {
  margin: 0;
}
.film-poster {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  position: relative;
  background: #141414;
  color: #f0ece3;
  cursor: pointer;
}
.film-poster img {
  display: block;
  width: 100%;
  max-height: 620px;
  object-fit: cover;
  aspect-ratio: 16/9;
}
.film-poster span {
  position: absolute;
  bottom: 24px;
  left: 24px;
  background: rgba(0, 0, 0, 0.72);
  padding: 14px 24px;
  border: 0;
  border-radius: var(--r-pill, 999px);
}
figcaption {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 0;
  color: #bdb7aa;
}
a {
  color: #c5af7f;
}
button {
  min-height: 44px;
}
button:focus-visible,
a:focus-visible {
  outline: 2px solid #c5af7f;
  outline-offset: 5px;
}
dialog {
  width: min(1000px, 94vw);
  padding: 24px;
  border: 0;
  border-radius: var(--r-lg, 18px);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.7);
  background: var(--bg0, #000);
  color: #eee9df;
}
dialog::backdrop {
  background: #000d;
}
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
h2 {
  font-size: 22px;
  margin: 0;
}
header button {
  background: var(--tint-2, rgba(255, 255, 255, 0.06));
  color: var(--ink-2, #b4b4b0);
  border: 0;
  border-radius: var(--r-pill, 999px);
  padding: 8px 18px;
  cursor: pointer;
}
iframe {
  width: 100%;
  aspect-ratio: 16/9;
  border: 0;
  display: block;
}
</style>
